import { actions } from 'actions';

const initialState = {};

const progressRateReducer = (state = initialState, action ) => {
  switch (action.type) {
    case actions.SET_PROGRESSRATE:
      return {
        progressRate: action.progressRate,
        num: action.num,
        total: action.total
      };
    case actions.CLEAR_PROGRESSRATE:
      return {};
    default:
      return state;
  }
};

export default progressRateReducer;